module.exports = __webpack_public_path__ + "static/media/arrow-right.e44b8dc8.svg";